import { ClaudeTemplate } from "../types";

/** Meta Ads Manager: Facebook, Instagram o ambos. */
export const metaTemplate: ClaudeTemplate = {
  id: "meta",
  tool: "Meta Ads Manager",
  url: "https://adsmanager.facebook.com/",
  hierarchy: "Business portfolio → Ad account → Campaign → Ad set → Ad",
  idHint:
    'columna "Campaign ID" (añádela desde Columns si no se ve) o el parámetro selected_campaign_ids de la URL',
  accountField: "metaAdAccountIds",
  steps: `
### 1. Entrar en la cuenta publicitaria (puede que ya estés dentro)
1. Abre Meta Ads Manager ({{url}}). Si ya está abierto, sigue.
2. Elige el **Business portfolio** de la agencia o del cliente y, dentro, la **Ad account** de {{client}}. ID(s) conocidos: {{accountIds}} (puede venir con o sin el prefijo "act_"). Si no hay ID, búscala por nombre; si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, pulsa "Create":
   - Objetivo según {{goal.kpi}}: CPM → Awareness; CPC → Traffic; CPV → Engagement (video views); CPE → Engagement; CPL → Leads; CPA → Sales.
   - Si el tipo de campaña es SOCIAL_POSTS (promocionar publicaciones), el objetivo suele ser Engagement o Awareness y el anuncio usa una publicación existente.
   - Campaign name: {{names.order}}
   - Special ad categories: ninguna, salvo que el sector lo exija (crédito, empleo, vivienda, política). Si dudas, pregunta.
   - Advantage campaign budget: desactivado (el presupuesto va en el ad set), salvo que las notas digan otra cosa.

### 3. Ad set
1. Ad set name: {{names.line}}
2. Budget & schedule: **Lifetime budget** {{goal.budget}}, del {{goal.startDate}} al {{goal.endDate}}. Moneda de la cuenta: comprueba que es {{goal.currency}}; si no lo es, para y pregunta.
3. Puja: la estrategia por defecto (Highest volume). Si el objetivo es CPM / CPC y las notas piden coste controlado, usa "Cost per result goal" / "Bid cap" en torno a {{goal.netUnitCost}} y dímelo.
4. Audience:
   - Locations: {{target.geography}} (país {{goal.country}}).
   - Age: {{target.age}}. Gender: {{target.gender}}. Languages: {{target.language}}.
   - Detailed targeting (intereses): {{target.interests}}.
   - Custom / lookalike audiences: {{target.audience}}. Si no existen en la cuenta, no las crees: apúntalo.
   - Exclusiones: {{target.exclusions}}.
   - Si Meta ofrece "Advantage+ audience", déjalo desactivado para respetar la segmentación del briefing, salvo que las notas digan lo contrario.
5. Placements: según las notas de esta línea (solo Facebook, solo Instagram o ambos). Usa "Manual placements" para limitar a esas plataformas.
6. Devices: {{target.technology}}.

### 4. Ad
1. Identity: la página de Facebook y la cuenta de Instagram de {{brand}} / {{client}}. Si hay varias, pregunta.
2. Ad name: {{names.line}} (si hay varias piezas, añade un sufijo _01, _02…).
3. Formato: imagen, vídeo o carrusel según las piezas del bloque "Creatividades". En SOCIAL_POSTS, elige "Use existing post" con la publicación indicada en el briefing; si no se indica, pregunta.
4. Primary text, headline, description y CTA: bloque "Copies".
5. Website URL: bloque "URLs de destino". Los UTM, en el campo "URL parameters".
6. Pixel / dataset de conversiones: el del cliente, si existe y el objetivo lo necesita.
7. Publica todo como **borrador** o con la campaña **en pausa**: no pulses "Publish" sin mi confirmación.
`,
};
